import Csv from './Csv';
import _ from 'underscore';
import { mean, std, round } from 'mathjs';

export default class DataManager{
    constructor(onReady){
        this.asOfDate = 'NOT FOUND IN DISCLOSURE HEADER!';
		this.client = process.env.REACT_APP_CLIENT
		this.dataLocation = "aci"
		if (this.client === 'grpaa') this.dataLocation = "grpaa"
        this.init(onReady); 
    }

	

    async init(onReady){            
        this.weightings = await this.readWeightings();
        this.funds = await this.readFunds();
        this.glides = await this.readGlides();
        this.disclosures = await this.readDisclosures();
        this.optimals = await this.readOptimals();
        onReady();
    }

    async readWeightings(){
        let weightingsObject = {};
        let weightings = await this.readFile(this.dataLocation + '/weightings.csv');    
       // console.log("weightings csv from file:",weightings);
        weightings.forEach((row, index) => {
            if (index === 0)return;
            if (!row[1])return;

            let q = row[0];
            let a = row[1];
            if (!weightingsObject[q])weightingsObject[q] = {};
            let props = this.setPropsFromRow(row, 3);
            weightingsObject[q][a] = Object.assign({}, props, { _points: parseInt(row[2]) });
        });   

        //console.log("weightings csv:",weightingsObject);

        return weightingsObject;
    }

    async readFunds(){
        let fundsObject = {};
        let funds = await this.readFile(this.dataLocation + '/funds_Optimal.csv');   

        funds.forEach((row, index) => {
            if (index === 0)return;
            if (!row[0])return;

            let id = row[0];
            fundsObject[id] = Object.assign(this.setPropsFromRow(row, 3), {
                id: id,
                ticker: row[1],
                display: row[2],
                Growth_R: row[11],
                Market_R: row[12],
                Macro_R: row[13],
                Income_R: row[14],
                Growth_Y:row[15],
                Drawdown_X:row[16]                
            });
        });   
        //console.log("fundsObject=========00:",fundsObject);
        return fundsObject;
    }

    async readGlides(){
        let glides = await this.readFile(this.dataLocation + '/glide.csv');

        let output = {};
        let unzipped = _.unzip(glides);
        _.each(unzipped, function(values, index){
            if (index === 0)return;
            output[values[0]] = [];      
            _.each(values, (point, count) => {
                if (count === 0)return;
                if (point)output[values[0]].push(point);
            });        
        });     

        return output;
    } 
    
    async readOptimals(){
        let optimals = await this.readFile(this.dataLocation + '/glide_optimal.csv');
        let output = {};
        let unzipped = _.unzip(optimals);
        _.each(unzipped, function(values, index){
            if (index === 0)return;
            output[values[0]] = [];      
            _.each(values, (point, count) => {
                if (count === 0)return;
                if (point)output[values[0]].push(point);
            });        
        });
        return output;
    }    

    async readDisclosures(){
        let self = this;
        let glides = await this.readFile(this.dataLocation + '/disclosure.csv');
        let output = {};

        _.each(glides, function(values, index){
            if (index === 0){
                let asOfBits = values.join().split('as of');                
                if (asOfBits[1]){
                    let cleaned = asOfBits[1].trim().split(/[^\d|/]/)[0];
                    if (cleaned)self.asOfDate = cleaned.trim();
                }
                return;
            }
            output[values[1]] = values;      
        });  
        
        return output;        
    }  

    setPropsFromRow(row, startIndex){
        let output = {};
        this.getProps().forEach((prop, index) => {
            output[prop] = row[startIndex + index];
        });
        return output;
    }

    getBlankPropsObject(){
        let output = {};
        this.getProps().forEach(prop => {
            output[prop] = 0;
        });
        return output;
    }

    getProps(){
        return [ 'Growth','Volatility','Returns','Drawdown','Inflation','Interest','Currency','Income' ];
    }

    calculateWeightings(responses){           
        //console.log("calculateWeightings:===00:",responses);
        let output = Object.assign({ _total: 0 }, this.getBlankPropsObject());
        
        Object.keys(responses).forEach(qid => {
            if(parseInt(qid)>=8){
                let response = responses[qid];
                let qObj = this.weightings[qid];         
                if (qObj && response.selected && qObj[response.selected.id]){
                    let aObj = qObj[response.selected.id];
                    Object.keys(aObj).forEach(key => {
                        if (key === "_points")return;
                        let pqWeight = aObj._points;  
                        let value = (aObj[key] * pqWeight);
                        output[key] = output[key] + value;
                        output._total += value;
                    });
                }
            }
        });

        Object.keys(output).forEach(key => {
            if (key === '_total')return;
            if (key === '_points')return;
            if (output._total === 0)return;
            output[key] = output[key] / output._total;
        });

        return output;
    }

    calculateRankings(weightings){        
        let rankings = [];

        Object.values(this.funds).forEach(fund => {
            let output = {
                id: fund.id,
                ticker: fund.ticker,
                display: fund.display,
                rankRaw: 0,
                Growth_R: fund.Growth_R,
                Market_R: fund.Market_R,
                Macro_R: fund.Macro_R,
                Income_R: fund.Income_R
            };
            this.getProps().forEach((prop, index) => {
                output.rankRaw += (fund[prop] * weightings[prop]);
            });
            output.rank = round(output.rankRaw, 1);
            output.grouped = this.calculateGroupedRisks(output.individual);
            rankings.push(output);
        });

        rankings = _.sortBy(rankings, (r) => r.rank);

        let rankingsArr = rankings.map(r => r.rank);
        let avg = mean(rankingsArr);
        let sd = std(rankingsArr);
        let q1 = this.quantile(rankingsArr, .25);
        let q2 = this.quantile(rankingsArr, .50);
        let q3 = this.quantile(rankingsArr, .75);

        //console.log('Percentiles:', q1, q2, q3, '...');
        //console.log('Rankings: ', rankings.map(r => r.display + ':' + r.rank));

        rankings.forEach(ranking => {
            ranking.zScore = (ranking.rank - avg)/sd;
            ranking.quartile = ranking.rank < q1 ? 1 : (ranking.rank < q2 ? 2 : (ranking.rank < q3 ? 3 :4 ));
        });

        return rankings;
    }

    calculateBullBear(weightings){
        let limitTo = 10;
        let harmonize = 1;
        let bull = (weightings.Growth  + weightings.Inflation + weightings.Interest + weightings.Currency) * 100;
        let bear =  (weightings.Volatility + weightings.Returns + weightings.Drawdown + weightings.Income) * 100;
        let bb = (bear - bull)/harmonize;
        bb = Math.round(bb < -limitTo ? -limitTo : (bb > limitTo ? limitTo : bb));
        return bb;
    }

    calculateSimpleWeightings(weightings, getRawValues){
        if (!weightings)return null;
        let total = weightings.Growth  + weightings.Inflation + weightings.Interest + weightings.Currency + weightings.Volatility + weightings.Returns + weightings.Drawdown + weightings.Income;
        let outputValues = {
            growth: Math.round((weightings.Growth / total) * 100),
            market: Math.round((weightings.Volatility + weightings.Returns + weightings.Drawdown / total) * 100),
            macro: Math.round((weightings.Inflation + weightings.Interest + weightings.Currency / total) * 100),
            income: Math.round((weightings.Income / total) * 100)
        };

        if (getRawValues){
            return outputValues;
        }
        
        let output = {
            growth: 50,
            market: 50,
            macro: 50,
            income: 50
        };
        
        if (outputValues.market > 65)output.market = 100;
        if (outputValues.market < 30)output.market = 0;

        if (outputValues.growth > 65)output.growth = 100;
        if (outputValues.growth < 30)output.growth = 0;

        if (outputValues.macro > 15)output.macro = 100;
        if (outputValues.macro < 7)output.macro = 0;
        
        if (outputValues.income > 20)output.income = 100;
        if (outputValues.income < 5)output.income = 0;        
                        
        return output;
    } 

    calculateGroupedRisks(individual){
        if (!individual)return null;
        let total = 1;
        let outputValues = {
            growth: Math.round((individual.Growth / total)),
            market: Math.round((individual.Volatility + individual.Returns + individual.Drawdown / total)),
            macro: Math.round((individual.Inflation + individual.Interest + individual.Currency / total)),
            income: Math.round((individual.Income / total))
        };

        let output = Object.assign({}, outputValues, {
            market_rank: 2,
            growth_rank: 2,
            macro_rank: 2,
            income_rank: 2
        });
        
        if (outputValues.market > 65)output.market_rank = 3;
        if (outputValues.market < 30)output.market_rank = 1;

        if (outputValues.growth > 65)output.growth_rank = 3;
        if (outputValues.growth < 30)output.growth_rank = 1;

        if (outputValues.macro > 15)output.macro_rank = 3;
        if (outputValues.macro < 7)output.macro_rank = 1;
        
        if (outputValues.income > 20)output.income_rank = 3;
        if (outputValues.income < 5)output.income_rank = 1;        
                        
        return output;        
    } 

    async getConfig(){
        let response = await fetch(process.env.PUBLIC_URL + '/data/config.json?ts=' + (new Date().getTime()));
        let configHashed = await response.json();  
        let config = JSON.parse(atob(configHashed.data));
        return config;
    }

    async readFile(path){
        let response = await fetch(process.env.PUBLIC_URL + '/data/' + path + '?ts=' + (new Date().getTime()));
        let text = await response.text();
        var csv = new Csv();
        return csv.fromString(text);
    }    

    quantile(arr, q){
   
        const sorted = arr.sort(function(a, b) {
			return a - b;
		  })

        const pos = (sorted.length - 1) * q;
        const base = Math.floor(pos);
        const rest = pos - base;
        if (sorted[base + 1] !== undefined) {
            return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
        } else {
            return sorted[base];
        }
    };
}
